import React, { memo } from 'react';
import { Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useRequest } from 'ahooks';
import { RootState } from '@/models';
import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
import UnlockFailModalContent from '../UnlockFailModalContent';
import styles from './index.module.scss';

const controller = new ConBrandDetailsWebController();

export type UnlockConfirmModalContentProps = {
  conBrandId?: string;
  onUnlocked?: () => void;
};

const UnlockConfirmModalContent: React.FC<UnlockConfirmModalContentProps> = ({ conBrandId, onUnlocked }) => {
  const { memberInfo } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const { run } = useRequest(
    async () => {
      const res = await controller.conBrandDetailsWebControllerV1UnlockBrandUsingPut1({
        conBrandId,
      });
      return res.data;
      ``;
    },
    {
      manual: true,
      onSuccess(res) {
        if (res.code !== 200) {
          message.error(res.msg);
          return;
        }
        if (!res.data.unlockSuccess) {
          dispatch({
            type: 'modal/open',
            payload: {
              content: <UnlockFailModalContent />,
            },
          });
        } else {
          dispatch({
            type: 'modal/close',
          });
          onUnlocked?.();
          message.success(res.msg);
        }
      },
    }
  );
  return (
    <section className={styles.content}>
      <img src="//assets-oss.cbndata.com/cbndata-refactor-fe/Fhp4ZnCqpYsqRyRPLUgqkAXF1UWW.svg" alt="解锁查看" />
      <h1 className={styles.title}>解锁查看</h1>
      <div className={styles.textContent}>
        <span className={styles.text}>{`您已开通中国新消费品牌数据库会员（${memberInfo?.memberTypeName}）`}</span>
        <span className={styles.text}>是否解锁查看完整数据？</span>
      </div>
      <Button className={styles.unlockBtn} type="primary" size="large" onClick={run}>
        解锁
      </Button>
      <span
        className={styles.tips}
      >{`当前已添加（${memberInfo?.alreadyUnLockNum}/${memberInfo?.totalCanUnLockNum}）`}</span>
    </section>
  );
};

export default memo(UnlockConfirmModalContent);
